import gql from 'graphql-tag';

export default gql`
  mutation copyFilesToFolderFileMutation($items: [CopyItemInput!]!, $targetFolderId: ID!) {
    copyFilesToFolderFileMutation(items: $items, targetFolderId: $targetFolderId) {
      copiedCount
      errors
    }
  }
`;
